import React from 'react';
import Rnd from 'components/Rnd';
import { useIsInteractionDisabled } from 'containers/EditSceneModal/state';
import useCaptionsDragAlignment from './useCaptionsDragAlignment';
import useCaptionsDragHandlers from './useCaptionsDragHandlers';
import useCaptionsPosition from './useCaptionsPosition';

export type EditSceneCaptionsLayerRndProps = {
  children?: React.ReactNode;
  captionsPositionStyle?: React.CSSProperties;
};

const EditSceneCaptionsLayerRnd: React.FC<EditSceneCaptionsLayerRndProps> = ({
  captionsPositionStyle,
  children,
}) => {
  const { isInteractionDisabled } = useIsInteractionDisabled();

  const { position, size } = useCaptionsPosition({ captionsPositionStyle });

  const { handleDragStart, handleDragStop } = useCaptionsDragHandlers();

  const {
    dragAxis,
    handleDrag,
    handleDragStart: handleDragAlignmentStart,
    handleDragStop: handleDragAlignmentStop,
    guidelines,
  } = useCaptionsDragAlignment({
    size,
    onDragStart: handleDragStart,
    onDragStop: (e, dragData, snapData) =>
      handleDragStop(e, { ...dragData, x: snapData?.x, y: snapData?.y }),
  });

  return (
    <>
      {guidelines}
      <Rnd
        bounds="parent"
        disableOutline={false}
        disableDragging={isInteractionDisabled}
        dragAxis={dragAxis}
        enableResizing={false}
        onDrag={handleDrag}
        onDragStart={handleDragAlignmentStart}
        onDragStop={handleDragAlignmentStop}
        position={position}
        size={size}
      >
        {children}
      </Rnd>
    </>
  );
};

export default EditSceneCaptionsLayerRnd;
